import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "./auth";

const BrandingContext = createContext({});
const DEFAULT = {
  product_name: "RemediScore Performance Suite",
  company_display_name: "RemediScore",
  login_tagline: "Measure what matters. Coach what counts.",
  primary_color: "#0EA5E9",
  secondary_color: "#0284C7",
};

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(DEFAULT);

  useEffect(() => {
    if (!user) { setBranding(DEFAULT); return; }
    api.get("/branding").then(({ data }) => {
      setBranding(data);
      if (data.product_name) document.title = data.product_name;
    }).catch(() => setBranding(DEFAULT));
  }, [user]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext) || DEFAULT;
